/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Moment from 'moment';
import ConfigD from './util/ConfigD';
import Helpers from './util/Helpers'
import './css/loginForm.css'
import './css/step.css'
import 'jquery-validation';
import $ from 'jquery';
import TotalNaturezaPeriodoGrafBarra from './relatorios/Natureza/TotalNaturezaPeriodoGrafBarra'
import TempoRespostaFaixaGrafBarra from './relatorios/TempoResposta/TempoRespostaFaixaGrafBarra'
import TotalHierarquiaAssuntosEstruturaGrafBarra from './relatorios/Assunto/hierarquia/TotalHierarquiaAssuntosEstruturaGrafBarra'
import PainelTotalManifestacoes from './relatorios/painelDashboard/PainelTotalManifestacoes'
import IndicadorTempoRespostaFaixa from './relatorios/IndicadorTempoRespostaFaixa'


//https://stackoverflow.com/questions/22002626/does-bootstrap-3-have-a-pre-built-steps-option-for-forms
//https://github.com/react-component/slider
//http://react-component.github.io/slider/examples/handle.html

//https://github.com/ritz078/react-slider

//https://github.com/whoisandy/react-rangeslider
//https://whoisandy.github.io/react-rangeslider/
//
var d = new Date();
var anoAtual = d.getFullYear();
class DashboardPage extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            natureza: !$.isEmptyObject(this.props.params) && this.props.params.natureza ? this.props.params.natureza : 'geral',
            uf: !$.isEmptyObject(this.props.params) && this.props.params.uf ? this.props.params.uf : '',
            canal: !$.isEmptyObject(this.props.params) && this.props.params.canal ? this.props.params.canal : 'intranet',
            grupoTratamento: !$.isEmptyObject(this.props.params) && this.props.params.grupo ? this.props.params.grupo : 'ouvidoria',
            parametrosPesquisaRelatorio:{},
            dadosRelatorioNatureza:0

        };
        this.getNatureza = this.getNatureza.bind(this);
        this.getDadosRelatorioNatureza = this.getDadosRelatorioNatureza.bind(this);
        this.getFaixa = this.getFaixa.bind(this);
        this.getDadosRelatorioTempoRespostaFaixa = this.getDadosRelatorioTempoRespostaFaixa.bind(this);
    }

    componentDidMount(){
        var data = {
            dtInicio: '01/01/'+anoAtual,
            dtFim: new Date(),
            idsEstrutura: '1',
            idsGrupo: '1',
            idsClassificacao: '1,4,5,6,11,12',
            idsSituacao: '',
            idEstruturaPai: 0
        }
        this.setState({parametrosPesquisaRelatorio:data});

    }

    getNatureza(valor){
        
        this.setState({naturezaGraficoSelecionada: valor});
        window.UIModals.showModal('#visualizarRelatorioAssuntoPorNatureza');
    }
    getDadosRelatorioNatureza(valor){
        
        this.setState({dadosRelatorioNatureza: valor});
    }

    getDadosRelatorioTempoRespostaFaixa(valor){
        
        this.setState({dadosRelatorioTempoRespostaFaixa: valor});
    }
    getFaixa(valor){
        
         this.setState({faixaSelecionada: valor});
         window.UIModals.showModal('#visualizarRelatorioNaturezaPorFaixa');
     }
    componentWillReceiveProps(nextProps) {

        
        //if(!$.isEmptyObject(nextProps.clienteLogado)){
           
            //enviar para página de oses desse cliente com a situação delas. 
            //this.context.router.push('/servico');
        //}
      
    }

    render() {
        //console.log('servicos', this.props.servicos);
        // if($.isEmptyObject(this.props.servicos)){
        //   return <div/>
        // }
        //console.log('natureza ' , this.state.natureza)

    return (
        
        <div>
            <div className="breadcrumb-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <h2 className="title">Dashboard</h2>
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <div className="breadcrumbs pull-right">
                                <ul>
                                    <li>Você está aqui:</li>
                                    <li><a href={ConfigD.getServerBase() === '' ? '/' : ConfigD.getServerBase()}>Home</a></li>
                                    <li>{this.state.tituloPagina}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className="container">
            <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12  bottom-pad ">
                        <p>Período: {'01/01/'+anoAtual} a {Moment().format('DD/MM/YYYY')} </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12  bottom-pad ">
                        <PainelTotalManifestacoes total={this.state.dadosRelatorioNatureza}/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12  bottom-pad ">
                        <IndicadorTempoRespostaFaixa parametrosPesquisaRelatorio={this.state.parametrosPesquisaRelatorio}  />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                            <h3 className="title">Manifestações por Assunto</h3>
                    </div>
                    <div className="clearfix"></div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate_afr bottom-pad">
                        <TotalHierarquiaAssuntosEstruturaGrafBarra parametrosPesquisaRelatorio={this.state.parametrosPesquisaRelatorio}  relatorioAssuntoHierarquizado={this.getDadosRelatorioAssuntoHierarquizado} tipicasOuvidoria={false} nomeGrafico={'graficoPrincipal'}  efetuarCruzamento={this.state.valueCruzamentoUsuario}/>
                    </div>
                        
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <h3 className="title">Manifestações por natureza</h3>
                    </div>
                    <div className="clearfix"></div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate_afr bottom-pad">
                        <TotalNaturezaPeriodoGrafBarra parametrosPesquisaRelatorio={this.state.parametrosPesquisaRelatorio} tipicasOuvidoria={false} obtemNaturezaSelecionada={this.getNatureza} relatorioNatureza={this.getDadosRelatorioNatureza}/>
                    </div>
                    
                </div>
            </div>
        </div>
    );
  }
}

DashboardPage.protoType = {
    actionCliente: PropTypes.object.isRequired
}
DashboardPage.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
            //clienteLogado: state.cliente

    };
}

function mapDispatchToProps(dispatch){
   return {
        
        //actionCliente: bindActionCreators(clienteActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



/** WEBPACK FOOTER **
 ** ./src/components/DashboardPage.js
 **/